import type * as React from 'react';
import { del } from '@Domain/Api';
import aiCostLimitDeleted, {
	type AiCostLimitDeletedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitDeleted';
import aiCostLimitDeletionFailed, {
	type AiCostLimitDeletionFailedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitDeletionFailed';
import type DeleteAiCostLimit from '@Application/AiCostLimits/Limits/Commands/DeleteAiCostLimit';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiCostLimitDeletedAction | AiCostLimitDeletionFailedAction;

export default (command: DeleteAiCostLimit) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-cost-limits/${command.limitId}`,
			);

			const action = aiCostLimitDeleted({ limitId: command.limitId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostLimitDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
